import environment from "environment";
import NazioniModel from "stores/simulazione/models/NazioniModel";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import AdministrativeCategoryModel from "./models/AdminisrativeCategoryModel";
import AuthorityTypeModel from "./models/AuthorityTypeModel";
import CanaliModel from "./models/CanaliModel";
import ConvenzioniModel from "./models/ConvenzioniModel";
import DocumentTypeModel from "./models/DocumentTypeModel";
import LookupManagementModel from "./models/LookupManagementModel";
import ProdottiModel from "./models/ProdottiModel";
import RequestedTypeModel from "./models/RequestedTypeModel";
import SegmentiModel from "./models/SegmentiModel";
import ComuniModel from "../simulazione/models/ComuniModel";
import TipoProdottoModel from "./models/TipoProdottoModel";
import AddressTypeModel from "./models/AddressTypeModel";
import AgentiProvvModel from "./models/AgentiProvvModel";
import SubLevelsModel from "./models/SubLevelsModel";
import LookUpModel from "./models/LookUpModel";

export interface IConvenzioniRequest {
    idRequestedType: number;
    idAdministrativeCategory: number;
    idSegment: number;
    idAdministration?: number | string;
}

export default class LookUpEffect {
    public static async lookupAdministrativeCategoryGet(
        idRequestedType?: string
    ): Promise<AdministrativeCategoryModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupAdministrativeCategoryGet;
        return EffectUtility.getToModel<AdministrativeCategoryModel[]>(AdministrativeCategoryModel, endpoint, {
            idRequestedType: idRequestedType,
        });
    }

    public static async lookupRequestedTypeGet(id: string): Promise<RequestedTypeModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupRequestedTypeGet;
        return EffectUtility.getToModel<RequestedTypeModel[]>(RequestedTypeModel, endpoint, {
            idAdmCategory: id,
        });
    }

    public static async lookupManagementGet(
        text: string,
        idAdmCategory?: string,
        includeExceptions?: boolean
    ): Promise<LookupManagementModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupManagementGet;
        return EffectUtility.postToModel<LookupManagementModel[]>(LookupManagementModel, endpoint, {
            text: text,
            idAdmCategory: idAdmCategory,
            includeExceptions: includeExceptions,
        });
    }

    public static async canaliGet(
        idAgent?: number,
        isAdmin?: boolean
    ): Promise<CanaliModel[] | HttpErrorResponseModel> {
        let endpoint: string = environment.api.lookupCanaliGet;
        if (isAdmin) endpoint = environment.api.lookupCanaliAdminGet;
        return EffectUtility.postToModel<CanaliModel[]>(CanaliModel, endpoint, {
            idAgent: idAgent,
        });
    }

    public static async agentiGet(): Promise<AgentiProvvModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupAgentiProvvigionaliGet;
        return EffectUtility.getToModel<AgentiProvvModel[]>(AgentiProvvModel, endpoint);
    }

    public static async segmentiGet(
        idRequestedType: number,
        idAdministrativeCategory: number,
        idChannel: number,
        idAgent?: number
    ): Promise<SegmentiModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupSegmentiGet;
        return EffectUtility.postToModel<SegmentiModel[]>(SegmentiModel, endpoint, {
            idRequestedType: idRequestedType,
            idAdministrativeCategory: idAdministrativeCategory,
            idChannel: idChannel,
            idAgent: idAgent,
        });
    }

    public static async prodottiGet(
        idRequestedType: number,
        idAdministrativeCategory: number,
        segment: string,
        idAgent?: number
    ): Promise<ProdottiModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupProdottiGet;
        return EffectUtility.postToModel<ProdottiModel[]>(ProdottiModel, endpoint, {
            idRequestedType: idRequestedType,
            idAdministrativeCategory: idAdministrativeCategory,
            segment: segment,
            idAgent: idAgent,
        });
    }

    public static async convenzioniGet(
        request: IConvenzioniRequest
    ): Promise<ConvenzioniModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupConvenzioniGet;
        return EffectUtility.postToModel<ConvenzioniModel[]>(ConvenzioniModel, endpoint, request);
    }

    public static async lookupDocumentTypesGet(): Promise<DocumentTypeModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupDocumentTypesGet;
        return EffectUtility.getToModel<DocumentTypeModel[]>(DocumentTypeModel, endpoint);
    }

    public static async lookupAuthorityTypesGet(): Promise<AuthorityTypeModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupAuthorityTypesGet;
        return EffectUtility.getToModel<AuthorityTypeModel[]>(AuthorityTypeModel, endpoint);
    }

    public static async nazioniGet(): Promise<NazioniModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookUpNazioniGet;
        return EffectUtility.getToModel<NazioniModel[]>(NazioniModel, endpoint);
    }

    public static async comuniGet(
        nazione: string,
        dataNascita?: string
    ): Promise<ComuniModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookUpComuniGet;
        return EffectUtility.getToModel<ComuniModel[]>(ComuniModel, endpoint, {
            searchFilter: nazione,
            dataNascita: dataNascita,
        });
    }

    public static async lookupProductTypesGet(): Promise<TipoProdottoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupProductTypesGet;
        return EffectUtility.postToModel<TipoProdottoModel[]>(TipoProdottoModel, endpoint);
    }

    public static async lookupAddressTypesGet(): Promise<AddressTypeModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupAddressTypesGet;
        return EffectUtility.getToModel<AddressTypeModel[]>(AddressTypeModel, endpoint);
    }

    public static async lookupSubLevelsGet(): Promise<SubLevelsModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupSubLevels;
        return EffectUtility.getToModel<SubLevelsModel[]>(SubLevelsModel, endpoint);
    }
    public static async lookupFilialiGet(): Promise<LookUpModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.filiali;
        return EffectUtility.getToModel<LookUpModel[]>(LookUpModel, endpoint);
    }
    public static async lookupSegnalazioniGet(): Promise<LookUpModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.segnalazioni;
        return EffectUtility.getToModel<LookUpModel[]>(LookUpModel, endpoint);
    }
    public static async lookupMotivCabioTAnGet(): Promise<LookUpModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lkMotivoCambioTan;
        return EffectUtility.getToModel<LookUpModel[]>(LookUpModel, endpoint);
    }
    public static async lookupStatoPrevGet(): Promise<LookUpModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupStatoPrev;
        return EffectUtility.getToModel<LookUpModel[]>(LookUpModel, endpoint);
    }
    public static async getParametroGet(parametro: string): Promise<string | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getParametro;
        return EffectUtility.getToModel<string>(null, endpoint, {
            parametro: parametro,
        });
    }
}
